import { useEffect, useState } from "react";

const useUserStatus = (userId) => {
  const [status, setStatus] = useState("");

  useEffect(() => {
    if (!userId) return;

    const fetchStatus = async () => {
      try {
        const res = await fetch(
          `https://pulse.tutify.online/teacher/${userId}`
        );
        if (!res.ok) throw new Error("Failed to fetch status");
        const data = await res.json();
        setStatus(data.status);
      } catch (err) {
        console.error("Error fetching status:", err);
      }
    };

    fetchStatus();

    // Optional: poll every X seconds
    const interval = setInterval(fetchStatus, 300000); // 300s
    return () => clearInterval(interval);
  }, [userId]);

  return status;
};

export default useUserStatus;
